// frontend/src/hooks/useDevice.ts
import { useState, useEffect } from 'react';

export interface DeviceState {
    isMobile: boolean;       // < 768px
    isTablet: boolean;       // >= 768px && < 1024px
    isDesktop: boolean;      // >= 1024px
    isTouch: boolean;        // Touch screen device
    isNative: boolean;       // Running inside Capacitor native app wrapper
    width: number;
    height: number;
}

export const useDevice = (): DeviceState => {
    const [deviceState, setDeviceState] = useState<DeviceState>(() => {
        const width = typeof window !== 'undefined' ? window.innerWidth : 1200;
        const height = typeof window !== 'undefined' ? window.innerHeight : 800;
        const isTouch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
        
        // Capacitor native check
        const isNative = typeof window !== 'undefined' && !!(window as any).Capacitor?.isNativePlatform();

        return {
            isMobile: width < 768,
            isTablet: width >= 768 && width < 1024,
            isDesktop: width >= 1024,
            isTouch,
            isNative,
            width,
            height
        };
    });

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            const isNative = !!(window as any).Capacitor?.isNativePlatform();

            setDeviceState({
                isMobile: width < 768,
                isTablet: width >= 768 && width < 1024,
                isDesktop: width >= 1024,
                isTouch,
                isNative,
                width,
                height
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return deviceState;
};
